import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Email from "@material-ui/icons/Email";
import Face from "@material-ui/icons/Face";
import BusinessIcon from "@material-ui/icons/Business";
import PhoneIcon from "@material-ui/icons/Phone";
import Edit from "@material-ui/icons/Edit";
import Language from "@material-ui/icons/Language";
import Assignment from "@material-ui/icons/Assignment";
import Event from "@material-ui/icons/Event";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import registerPageStyle from "assets/jss/material-dashboard-react/views/registerPageStyle.jsx";
import { API_GET, API_POST } from "../../../services/api.service";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

const { REACT_APP_SERVER_URL } = process.env;

class Customer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      user: props.user,
      notify: { open: false, message: "", color: "success" },
      fieldMessage: { phone: { msg: "", type: "" }, email: { msg: "", type: "" } },
      formValues: {
        name: "",
        firstname: "",
        lastname: "",
        email: "",
        accountType: "DEFAULT",
        gstNumber: "",
        website: "",
        salesSource: "Direct",
        entrySource: "Manual Entry",
        leadSource: "Direct",
        remark: "",
        company: "",
        phone: "",
        company_size: "< 5 employees",
        industry: "IT Solutions",
        expiryDate: new Date().toISOString().split('T')[0],
        allocatedTo: "",
        address: "",
        landmark: "",
        pincode: "",
      },
      editMode: false,
      showForm: false,
      selectedId: null,
      customerList: [],
       allocatedToOptions: [],
       EntrySourceOptions: [
        { key: "API", value: "API" },
        { key: "Manual Entry", value: "Manual Entry" },
        { key: "Bulk Upload", value: "Bulk Upload" },
        { key: "Marketplace Integrations", value: "Marketplace Integrations" }
      ],
      LeadSourceOptions: [
        { key: "Direct", value: "Direct" },
        { key: "Referral", value: "Referral" },
        { key: "Social Media", value: "Social Media" },
        { key: "Cold Call", value: "Cold Call" },
        { key: "Email Marketing", value: "Email Marketing" },
        { key: "Others", value: "Others" }
      ],
      CompanySize: [
        { key: "< 5 employees", value: "< 5 employees" },
        { key: "5 - 20 employees", value: "5 - 20 employees" },
        { key: "20 - 50 employees", value: "20 - 50 employees" },
        { key: "50 - 250 employees", value: "50 - 250 employees" },
        { key: "> 250 employees", value: "> 250 employees" }
      ],
      SignupSource: [
        { key: "Direct", value: "Direct" },
        { key: "Open Database", value: "Open Database" },
        { key: "Existing Leads", value: "Existing Leads" },
        { key: "Website", value: "Website" },
        { key: "Social Media", value: "Social Media" },
        { key: "B2B Portals", value: "B2B Portals" },
        { key: "Push Marketing", value: "Push Marketing" },
        { key: "Incoming Queries", value: "Incoming Queries" },
        { key: "Customer Visits", value: "Customer Visits" }
      ],
      AccountTypeOptions: [
        { key: "GST", value: "GST" },
        { key: "DEFAULT", value: "DEFAULT" }
      ],
      IndustryOption: [
        { key: "DSA", value: "DSA" },
        { key: "Education", value: "Education" },
        { key: "Real Estate", value: "Real Estate" },
        { key: "Manufacturer", value: "Manufacturer" },
        { key: "Tour & Travels", value: "Tour & Travels" },
        { key: "Ayurveda", value: "Ayurveda" },
        { key: "Automobile", value: "Automobile" },
        { key: "Ecommerce", value: "Ecommerce" },
        { key: "Healthcare", value: "Healthcare" },
        { key: "Agriculture", value: "Agriculture" },
        { key: "Consultancy", value: "Consultancy" },
        { key: "Retail Store", value: "Retail Store" },
        { key: "NGO", value: "NGO" },
        { key: "Individual", value: "Individual" },
        { key: "Software Development", value: "Software Development" },
        { key: "IT Solutions", value: "IT Solutions" },
        { key: "Others", value: "Others" }
      ]
    };
    document.title = "Customer Management";
  }

  componentDidMount() {
    this.loadCustomers();
    this.loadAllocatedUsers();
  }

  loadAllocatedUsers = async () => {
    try {
      const getSessionRequest = await API_GET(`get-session`);
      if (getSessionRequest && getSessionRequest.success) {
        const username = getSessionRequest.userInfo.id;
        const res = await API_GET(`register/GetAllMembersByUserId?id=${username}`);
        if (res && res.success) {
          const options = res.data.teams_membership.map(user => ({
            key: user.id,
            value: user.username,
            email: user.email
          }));
          this.setState({ allocatedToOptions: options });
        }
      }
    } catch (e) {
      console.error("Error loading allocated users", e);
    }
  }

  loadCustomers = async () => {
    try {
      const res = await API_POST('action/getdata', {
        root: 'customers',
        con: {admin: this.state.user.admin}
      });
      if (res && res.status) {
        this.setState({ customerList: res.data || [] });
      }
    } catch (e) {
      console.error("Error loading customers", e);
    }
  }

  handleEdit = (row) => {
    this.setState({
      editMode: true,
      showForm: true,
      selectedId: row._id,
      formValues: {
        name: row.name || "",
        firstname: row.firstname || "",
        lastname: row.lastname || "",
        email: row.email || "",
        accountType: row.accountType || "DEFAULT",
        gstNumber: row.gstNumber || "",
        website: row.website || "",
        salesSource: row.salesSource || "Direct",
        entrySource: row.entrySource || "Manual Entry",
        leadSource: row.leadSource || "Direct",
        remark: row.remark || "",
        company: row.company || "",
        phone: row.phone || "",
        company_size: row.company_size || "< 5 employees",
        industry: row.industry || "IT Solutions",
        expiryDate: row.expiryDate ? new Date(row.expiryDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
        allocatedTo: row.allocatedTo || "",
        address: row.address || "",
        landmark: row.landmark || "",
        pincode: row.pincode || "",
      }
    });
    window.scrollTo(0, 0);
  }

  resetForm = () => {
    this.setState({
      editMode: false,
      showForm: false,
      selectedId: null,
      formValues: {
        name: "",
        firstname: "",
        lastname: "",
        email: "",
        accountType: "DEFAULT",
        gstNumber: "",
        website: "",
        salesSource: "Direct",
        entrySource: "Manual Entry",
        leadSource: "Direct",
        remark: "",
        company: "",
        phone: "",
        company_size: "< 5 employees",
        industry: "IT Solutions",
        expiryDate: new Date().toISOString().split('T')[0],
        allocatedTo: "",
        address: "",
        landmark: "",
        pincode: "",
      }
    });
  }

  setForm = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formValues: {
        ...prevState.formValues,
        [name]: value
      }
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { formValues, editMode, selectedId } = this.state;

    try {
      if (!editMode) {
        // Check if customer already exists
        const checkRes = await API_POST('action/getdata', {
          root: 'customers',
          con: { email: formValues.email, admin: this.state.user.admin }
        });

        if (checkRes && checkRes.success && checkRes.data.length > 0) {
          this.setState({
            notify: { open: true, message: "Customer already present", color: "danger" }
          });
          return;
        }
      }


      const endpoint = editMode ? 'action/update' : 'action/addProspects';
      const payload = {
        admin: this.state.user.admin,
        ...formValues,
        updatedOn: new Date(),
      };

      if (!editMode) {
        payload.createdOn = new Date();
      }

      const queryData = editMode ? { _id: selectedId } : {};

      const res = await API_POST(endpoint, {
        root: editMode ? 'customers' : 'prospects',
        body: payload,
        querydata: queryData
      });

      if (res) {
        this.setState({
          notify: { open: true, message: `Customer ${editMode ? 'updated' : 'created'} successfully`, color: "success" }
        });
        this.resetForm();
        this.loadCustomers();
      } else {
        this.setState({ notify: { open: true, message: res.error || `Failed to ${editMode ? 'update' : 'create'} customer`, color: "danger" } });
      }
    } catch (err) {
      console.error("Error in handleSubmit:", err);
      this.setState({ notify: { open: true, message: "Error processing request", color: "danger" } });
    }
  };

  render() {
    const { classes } = this.props;
    const { formValues, editMode, showForm, customerList } = this.state;

    const columns = [
      {
        name: "Action",
        cell: (row) => (
          <Button color="info" justIcon size="sm" onClick={() => this.handleEdit(row)}>
            <Edit />
          </Button>
        ),
        width: "80px",
      },
      { name: "Created Date", selector: "createdOn", sortable: true, cell: row => row.createdOn ? new Date(row.createdOn).toLocaleDateString() : "" },
      { name: "Source", selector: "salesSource", sortable: true },
      { name: "Entry Source", selector: "entrySource", sortable: true },
      { name: "Lead Source", selector: "leadSource", sortable: true },
      { name: "Company", selector: "company", sortable: true },
      { name: "Address", selector: "address", sortable: true },
      { name: "Landmark", selector: "landmark", sortable: true },
      { name: "Pincode", selector: "pincode", sortable: true },
      { name: "Phone", selector: "phone", sortable: true },
      { name: "First Name", selector: "firstname", sortable: true },
      { name: "Last Name", selector: "lastname", sortable: true },
      { name: "Email", selector: "email", sortable: true },
      { name: "Account Type", selector: "accountType", sortable: true },
      { name: "GST Number", selector: "gstNumber", sortable: true },
      { name: "Website", selector: "website", sortable: true },
      { name: "Allocated To", selector: "allocatedTo", sortable: true, cell: (row) => {
          const allocatedUser = this.state.allocatedToOptions.find(u => u.key == row.allocatedTo);
          return allocatedUser ? allocatedUser.email : (row.allocatedUser || "");
        }
      },
      { name: "Remarks", selector: "remark", sortable: true },
      { name: "Company Size", selector: "company_size", sortable: true },
      { name: "Industry", selector: "industry", sortable: true }
    ];

    return (
      <>
        <Snackbar
          place="right"
          color={this.state.notify.color}
          message={this.state.notify.message}
          open={this.state.notify.open}
          closeNotification={() => this.setState({ notify: { open: false } })}
          close
        />
        <div >
          <GridContainer justify="center">
            {showForm && (
              <GridItem xs={12}>
                <form onSubmit={this.handleSubmit}>
                  <Card>
                    <CardHeader color="primary">
                      <h4 className={classes.cardTitleWhite}>{editMode ? 'Edit Customer' : 'Create Customer'}</h4>
                    </CardHeader>
                    <CardBody>
                      <GridContainer>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="First Name"
                            id="firstname"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "firstname",
                              value: formValues.firstname,
                              onChange: this.setForm,
                              required: true,
                              endAdornment: <InputAdornment position="end"><Face /></InputAdornment>
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Last Name"
                            id="lastname"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "lastname",
                              value: formValues.lastname,
                              onChange: this.setForm,
                              required: true,
                              endAdornment: <InputAdornment position="end"><Face /></InputAdornment>
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Email"
                            id="email"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "email",
                              value: formValues.email,
                              onChange: this.setForm,
                              required: true,
                              type: "email",
                              endAdornment: <InputAdornment position="end"><Email /></InputAdornment>
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Phone"
                            id="phone"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "phone",
                              value: formValues.phone,
                              onChange: this.setForm,
                              required: true,
                              endAdornment: <InputAdornment position="end"><PhoneIcon /></InputAdornment>
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Company"
                            id="company"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "company",
                              value: formValues.company,
                              onChange: this.setForm,
                              required: true,
                              endAdornment: <InputAdornment position="end"><BusinessIcon /></InputAdornment>
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Account Type"
                            id="accountType"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "accountType",
                              value: formValues.accountType,
                              onChange: this.setForm,
                              type: "select",
                              options: this.state.AccountTypeOptions
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="GST Number (Optional)"
                            id="gstNumber"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "gstNumber",
                              value: formValues.gstNumber,
                              onChange: this.setForm,
                              endAdornment: <InputAdornment position="end"><Assignment /></InputAdornment>
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Website"
                            id="website"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "website",
                              value: formValues.website,
                              onChange: this.setForm,
                              endAdornment: <InputAdornment position="end"><Language /></InputAdornment>
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Source"
                            id="salesSource"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "salesSource",
                              value: formValues.salesSource,
                              onChange: this.setForm,
                              type: "select",
                              options: this.state.SignupSource
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Entry Source"
                            id="entrySource"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "entrySource",
                              value: formValues.entrySource,
                              onChange: this.setForm,
                              type: "select",
                              options: this.state.EntrySourceOptions
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Lead Source"
                            id="leadSource"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "leadSource",
                              value: formValues.leadSource,
                              onChange: this.setForm,
                              type: "select",
                              options: this.state.LeadSourceOptions
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Company Size"
                            id="company_size"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "company_size",
                              value: formValues.company_size,
                              onChange: this.setForm,
                              type: "select",
                              options: this.state.CompanySize
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Industry"
                            id="industry"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "industry",
                              value: formValues.industry,
                              onChange: this.setForm,
                              type: "select",
                              options: this.state.IndustryOption
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Allocated To"
                            id="allocatedTo"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "allocatedTo",
                              value: formValues.allocatedTo,
                              onChange: this.setForm,
                              type: "select",
                              options: this.state.allocatedToOptions
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4}>
                          <CustomInput
                            labelText="Pincode"
                            id="pincode"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "pincode",
                              value: formValues.pincode,
                              onChange: this.setForm,
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                          <CustomInput
                            labelText="Address"
                            id="address"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "address",
                              value: formValues.address,
                              onChange: this.setForm,
                              multiline: true,
                              rows: 2
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                          <CustomInput
                            labelText="Landmark"
                            id="landmark"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "landmark",
                              value: formValues.landmark,
                              onChange: this.setForm,
                              multiline: true,
                              rows: 2
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12}>
                          <CustomInput
                            labelText="Remarks"
                            id="remark"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              name: "remark",
                              value: formValues.remark,
                              onChange: this.setForm,
                              multiline: true,
                              rows: 2
                            }}
                          />
                        </GridItem>
                      </GridContainer>
                    </CardBody>
                    <CardFooter>
                      <Button type="submit" color="primary">
                        {editMode ? 'Update Customer' : 'Create Customer'}
                      </Button>
                      <Button color="default" onClick={this.resetForm}>
                        Cancel
                      </Button>
                    </CardFooter>
                  </Card>
                </form>
              </GridItem>
            )}
            <GridItem xs={12}>
              <Card>
                <CardHeader color="info">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 className={classes.cardTitleWhite} style={{ margin: 0 }}>Customer List</h4>
                    <Button color="white" onClick={() => this.setState({ showForm: true, editMode: false })}>
                      New Customer
                    </Button>
                  </div>
                </CardHeader>
                <CardBody>
                  <DataTableExtensions
                    columns={columns}
                    data={customerList}
                    export={true}
                    print={false}
                  >
                    <DataTable
                      columns={columns}
                      data={customerList}
                      pagination
                      striped
                      highlightOnHover
                    />
                  </DataTableExtensions>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </>
    );
  }
}

Customer.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object
};

export default withStyles(registerPageStyle)(Customer);